export enum AuthState {
  loggedIn = 1,
  loggedOut = 2,
  loggingIn = 3,
  loginFailed = 4,
}

export const pattern = /((?![_.-])((?![_.-][_.-])[a-z\d_.-]){0,63}[a-z\d]@((?!-)((?!--)[a-z\d-]){0,63}[a-z\d]\.){1,2}([a-z]{2,14}\.)?[a-z]{2,14})|((\+84|0)+([3|5|7|8|9])+([0-9]{8})\b)/;
